import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './bridgestone-illustration.module.css'

const propTypes = {
    foregroundClassName: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const path = `
M7,27.36a.94.94,0,0,1,.08-.47q2.66-9.33,5.32-18.66a5.36,5.36,0,0,1,2.68-3.08,5,5,0,0,1,2.14-.58H33.66c.15,0,
.31.12.3.29s-.22.31-.37.42c-3.85,2.65-7.56,5.5-11.17,8.46s-6.87,5.82-10.14,8.92Q9.81,25,7.45,27.43A.29.29,0,0,1,7,
27.36ZM43.35,6.73a9.43,9.43,0,0,0-5.8-2.16H36.41l-.26,0Q31.73,20,27.31,35.49a4.54,4.54,0,0,1-3,2.88,6.45,6.45,0,0,
1-1.81.13H20q2.64-9.18,5.26-18.36c0-.17.14-.37,0-.53a.3.3,0,0,0-.44,0c-2,1.68-3.86,3.42-5.73,5.19q-4.76,4.52-9.23,
9.32c-2.83,3-5.59,6.17-8.19,9.42a.92.92,0,0,0-.13.21v.19a.33.33,0,0,1,.16.17H26a25.6,25.6,0,0,0,8.19-1.38,12.07,
12.07,0,0,0,4.93-3.33,13.81,13.81,0,0,0,2.9-6A10,10,0,0,0,42.11,29a7.42,7.42,0,0,0-1.52-3.14,8.9,8.9,0,0,
0-4.84-2.84c-.15,0-.37,0-.37-.22.8-.16,1.6-.31,2.38-.54a11.67,11.67,0,0,0,3.61-1.68,9.61,9.61,0,0,0,3.22-4.05,
13.24,13.24,0,0,0,1-3.49V10.93A6.66,6.66,0,0,0,43.35,6.73Z`

/**
 * Stateless function representing the bridgestone icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @param {string} [props.foregroundClassName] - The class name for the foreground svg path
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BellIcon width={12} />
 */
const BridgestoneIllustration = props => {
    const { className, foregroundClassName } = props

    return (
        <SvgIcon {...props} className={cx(styles['bridgestone-icon'], className)}>
            <path className={cx(styles['icon-foreground'], foregroundClassName)} d={path} />
        </SvgIcon>
    )
}

BridgestoneIllustration.defaultProps = defaultProps
BridgestoneIllustration.propTypes = propTypes

export { BridgestoneIllustration }
